import pluralize from "pluralize";
import React from "react";
import { getFormattedFocusTime } from "./utils/date";

export const TileSubtitle = ({
  focusTimeMinutesCost,
  numImpacts,
  isSelected = false,
}: {
  focusTimeMinutesCost: number;
  numImpacts: number;
  isSelected?: boolean;
}) => (
  <div className={`cw-caption ${isSelected ? "cw-text-onEmphasis" : ""}`}>
    {focusTimeMinutesCost === 0 ? (
      "No Focus Time lost"
    ) : (
      <span>
        <span className="cw-font-bold">{getFormattedFocusTime(focusTimeMinutesCost)}</span>
        &nbsp;Focus Time
      </span>
    )}
    {numImpacts > 0 && (
      <span>
        &nbsp;/&nbsp;
        <span className="cw-font-bold">{numImpacts}</span>
        &nbsp;{pluralize("inconvenience", numImpacts)}
      </span>
    )}
  </div>
);
